import { Label } from '@aibees/elephant/types/label';
import { arraysAreEqual } from '@aibees/shared/utils';
import { useMemo } from 'react';

interface UseLabelItemsComparisonParams {
  currentLabels: Label[];
  items: Label[];
}

export function useLabelItemsComparison({
  currentLabels,
  items,
}: UseLabelItemsComparisonParams) {
  const hasChanges = useMemo(
    () =>
      !arraysAreEqual(
        currentLabels.map((x) => x.id).sort(),
        items.map((x) => x.id).sort()
      ),
    [currentLabels, items]
  );

  const currentLabelIdsArray = useMemo(
    () => currentLabels.map((x) => x.id),
    [currentLabels]
  );

  const itemIds = useMemo(() => items.map((x) => x.id), [items]);

  const allCurrentLabelsExist = useMemo(
    () => currentLabelIdsArray.every((labelId) => itemIds.includes(labelId)),
    [currentLabelIdsArray, itemIds]
  );

  const allItemsExistInCurrentLabels = useMemo(
    () => itemIds.every((itemId) => currentLabelIdsArray.includes(itemId)),
    [itemIds, currentLabelIdsArray]
  );

  const removedItemIds = useMemo(
    () => currentLabelIdsArray.filter((labelId) => !itemIds.includes(labelId)),
    [currentLabelIdsArray, itemIds]
  );

  return {
    hasChanges,
    currentLabelIdsArray,
    itemIds,
    allCurrentLabelsExist,
    allItemsExistInCurrentLabels,
    removedItemIds,
  };
}
